<template>
  <div  class="min-h-screen min-w-screen font-satoshi overflow-hidden">
    <Header />
    <router-view></router-view>
    <AppFooter />
  </div>
</template>

<script>

import AppFooter from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'App',
  components: {
    AppFooter,
    Header,
  },
};

</script>

<style></style>
